<template>
  <v-col class="pa-0 d-line-divider">
    <v-divider />
  </v-col>
</template>

<script>

export default {
  name: 'FormDivider'
}
</script>
